<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/mr7aAW/tc-custom/9781524869083.jpg?1708400633541" alt="This image is the cover for the book I Must Belong Somewhere"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">I Must Belong Somewhere
      </h1>
      <p class="bookDescription body article font2">
        <p>With her third poetry collection, <i>I Must Belong Somewhere,</i> acclaimed writer Dawn Lanuza is returning to her most popular literary platform. Written during her year of rest and travel, this new collection speaks to the indescribable feelings of displacement and longing for the companionship she left behind. Touching on the difficult themes of body image, death, bullying, sexism, mental health, and injury, Lanuza brings her contemporary views and powerful honesty to address topics many are too scared to talk about. With its modern, global perspective, <i>I Must Belong Somewhere</i> is sure to resonate with a wide array of readers.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dawn Lanuza
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Andrews McMeel Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b9d28266